import React from "react";
import PropTypes from "prop-types";
import { withUser } from "@unifiedpatents/sso";
import { Button } from "antd";
import { intersection as _intersection } from "lodash";

const styles = {
  container: {
    padding: 16,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  help: {
    flex: 1,
    textAlign: "center"
  }
};

const UserAccess = props => {
  const { user, allowedRoles, isPublicSignupAllowed, showHelp, helpText, helpButtonSize, children, style } = props;
  const { status, metadata, action } = user;
  const isRoleAllowed = _intersection(metadata.authorization.roles, allowedRoles).length > 0;
  return status.isLoggedIn ? (
    isRoleAllowed || isPublicSignupAllowed ? (
      <div style={style}>{children}</div>
    ) : showHelp ? (
      <div style={styles.container}>
        <div style={styles.help}>
          <Button disabled={true} size={helpButtonSize}>
            {"Access Restricted"}
          </Button>
          <br />
          <a href="//www.unifiedpatents.com/join/" target="_blank" rel="noopener noreferrer">
            <small>{"Please upgrade your membership to gain full access."}</small>
          </a>
        </div>
      </div>
    ) : null
  ) : showHelp ? (
    <div style={styles.container}>
      <div style={styles.help}>
        <Button type="primary" size={helpButtonSize} onClick={action.showLoginPopup}>
          {helpText}
        </Button>
        <br />
        <a onClick={action.showSignupPopup}>
          <small>{"Not a member? Sign up for free!"}</small>
        </a>
      </div>
    </div>
  ) : null;
};
UserAccess.propTypes = {
  allowedRoles: PropTypes.array,
  isPublicSignupAllowed: PropTypes.bool, // usually users without any role, because they sign up by themselves
  showHelp: PropTypes.bool,
  helpText: PropTypes.string,
  helpButtonSize: PropTypes.string
};
UserAccess.defaultProps = {
  allowedRoles: ["admin", "member-data"],
  isPublicSignupAllowed: false,
  showHelp: true,
  helpText: "Please Login to Access",
  helpButtonSize: "default"
};

export default withUser(UserAccess);
